<div class="control-line mat-elevation-z8">
  <div class="filter-actions-line">

    <mat-form-field appearance="outline">
      <mat-label>Market</mat-label>
      <mat-select id="marketSelect" data-testid="marketSelect" [value]="selectedMarketId()"
                  (selectionChange)="onMarketSelected($event.value)" (openedChange)="onMarketOpened($event)">
        <div class="mat-select-search-container" (click)="$event.stopPropagation()">
          <input #marketFilterInput matInput placeholder="Search markets..." [value]="marketQuery()"
                 (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" (input)="onMarketQuery($event)" />
          <mat-icon class="mat-select-search-icon">search</mat-icon>
        </div>

        <mat-option *ngFor="let m of marketsFiltered(); trackBy: trackByMarketId" [value]="m.id">
          {{ m.regionName }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Disposal Site</mat-label>
      <mat-select id="disposalSiteSelect" data-testid="disposalSiteSelect" [value]="selectedSiteId()"
                  (selectionChange)="onSiteSelected($event.value)" (openedChange)="onSiteOpened($event)">
        <div class="mat-select-search-container" (click)="$event.stopPropagation()">
          <input #marketFilterInput matInput placeholder="Search disposal sites..." [value]="siteQuery()"
                 (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" (input)="onSiteQuery($event)" />
          <mat-icon class="mat-select-search-icon">search</mat-icon>
        </div>

        <mat-option *ngFor="let m of sitesFiltered(); trackBy: trackBySiteId" [value]="m.id">
          {{ m.siteName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>
</div>
<div class="vol-grid mar-top-20">
  <!--====================
      CARD 1: DOSING RATES
  =====================-->
  <div class="vol-card">
    <!-- CARD HEADER -->
    <div class="vol-card-header">
      <span class="vol-card-title">Dosing Rates</span>
      <div class="add-dosingrates-button-container">
        @if(controlPermissions.addButton){
          <button mat-raised-button color="primary" (click)="openAddEditForm(null, 'Add')"
            [disabled]="selectedSiteId() === null">
            <mat-icon>add</mat-icon>Add
          </button>
        }
        @if(controlPermissions.duplicate){
          <button mat-raised-button color="primary" (click)="openAddEditForm(null, 'Duplicate')"
            [disabled]="isDuplicateDisabled()">
            <mat-icon>content_copy</mat-icon>Duplicate
          </button>
        }
      </div>
      <mat-icon class="vol-maximize-btn" (click)="openFullscreen('dosing')">open_in_full</mat-icon>
    </div>
    <div class="vol-card-content">
      <div class="vol-inner">
        <div [hidden]="((dataSourceDosing?.data?.length ?? 0) === 0)">
          <table class="fixed_headers">
            <thead>
              <tr>
                <th *ngFor="let col of dosingColumns" [attr.title]="col.header">
                  {{ col.header }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of dataSourceDosing.data">
                <td *ngFor="let col of dosingColumns" [ngStyle]="getDosingCellStyle(col.key)">
                  
                  <ng-container *ngIf="col.header === 'Action'; else valueCell">
                    <button mat-icon-button
                            type="button"
                            title="Edit"
                            (click)="openAddEditForm(row, 'Edit')">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>

                  <ng-template #valueCell>
                    <ng-container [ngSwitch]="col.type">
                      <span *ngSwitchCase="'date'">
                        {{ row[col.key] | date:'shortDate' }}
                      </span>
                      <span *ngSwitchCase="'number'">
                        {{ row[col.key] }}
                      </span>
                      <span *ngSwitchDefault>
                        {{ row[col.key] ?? '-' }}
                      </span>
                    </ng-container>
                  </ng-template>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>



  <!--===========================
      CARD 2: PROJECTED VOLUME (CHART)
  ===========================-->
  <div class="vol-card">
    <div class="vol-card-header">
      <span class="vol-card-title">Projected Volume</span>
      <button class="vol-download-btn" (click)="openProjectedVolume()">
        <mat-icon class="vol-maximize-btn" (click)="openFullscreen('projected')">open_in_full</mat-icon>
      </button>
    </div>

    <div class="vol-card-content">

      <div class="chart-wrapper">
        <canvas #projectedVolumeChart></canvas>
      </div>
    </div>
  </div>


  <!--===========================
      CARD 3: NUTRITIONAL FACTS
  ===========================-->
  <div class="vol-card">
    <div class="vol-card-header">
      <span class="vol-card-title">Nutritional Facts</span>
      <mat-icon class="vol-maximize-btn" (click)="openFullscreen('nutrition')">open_in_full</mat-icon>

    </div>

    <div class="vol-card-content">
      <div class="vol-inner">
        <div [hidden]="((nutritionalFacts()?.length ?? 0) === 0)">
          <table class="fixed_headers">
            <thead>
              <tr>
                <th></th>
                <th>Last Week</th>
                <th>This Week</th>
                <th>Next Week</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of nutritionalFacts()"
                  [ngClass]="item.DisplayText === 'Nutritional Facts' ? 'nutheader' : ''">

                <td>{{ item.DisplayText }}</td>
                <td>{{ item.LastWeek }}</td>
                <td>{{ item.ThisWeek }}</td>
                <td>{{ item.NextWeek }}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>


  <!--===========================
      CARD 4: PROJECTED VOLUME TABLE
  ===========================-->
  <div class="vol-card">
    <div class="vol-card-header">
      <span class="vol-card-title">Projected Volume Table</span>
      <mat-icon class="vol-maximize-btn" (click)="openFullscreen('table')">open_in_full</mat-icon>
    </div>
    <div class="vol-card-content">
      <div class="vol-inner">
        <table class="fixed_headers">
          <thead>
            <tr>
              <th *ngFor="let col of projectedColumns">
                {{ col.header }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of projectedRows()">
              <td *ngFor="let col of projectedColumns">
                <ng-container [ngSwitch]="col.type">

                  <span *ngSwitchCase="'date'">
                    {{ row[col.key] | date:'shortDate' }}
                  </span>

                  <span *ngSwitchCase="'number'">
                    {{ row[col.key] }}
                  </span>

                  <span *ngSwitchDefault>
                    {{ row[col.key] ?? '-' }}
                  </span>

                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <!-- <div class="empty-state">
        No projected volume table data available
      </div> -->
    </div>
  </div>


  <!--===========================
      FULLSCREEN  OVERLAY
  ===========================-->
  <div class="fullscreen-overlay" *ngIf="fullscreenCard() !== null">
    <div class="fullscreen-card">

      <div class="fullscreen-header">
        <span>
          {{
          fullscreenCard() === 'dosing' ? 'Dosing Rates' :
          fullscreenCard() === 'projected' ? 'Projected Volume' :
          fullscreenCard() === 'nutrition' ? 'Nutritional Facts' :
          'Projected Volume Table'
          }}
        </span>

        <button mat-icon-button (click)="closeFullscreen()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="fullscreen-content">

        <!-- Fullscreen: DOSING RATES TABLE -->
        <ng-container *ngIf="fullscreenCard() === 'dosing'">
          <div>
            <div class="add-stream-button-container">
              <button mat-raised-button color="primary" class="add-dosing-btn" (click)="openAddEditForm(null, 'Add')"
                [disabled]="selectedSiteId() === null">
                <mat-icon>add</mat-icon>Add Dosing Rate
              </button>
            </div>
            <div class="fullscreen-table-wrapper mat-elevation-z2">
              <table class="fixed_headers viewport dosinggridheight fullscreen_fixed_headers" style="width:99%">
                <thead>
                  <tr>
                    <th *ngFor="let col of dosingColumns" [attr.title]="col.header">
                      {{ col.header }}
                    </th>
                  </tr>
                </thead>

                <tbody style="width:101%;">
                  <tr *ngFor="let row of dataSourceDosing.data">
                    <td *ngFor="let col of dosingColumns">

                      <ng-container *ngIf="col.header === 'Action'; else dataCell">
                        <button mat-icon-button
                                type="button"
                                title="Edit"
                                (click)="openAddEditForm(row, 'Edit')">
                          <mat-icon>edit</mat-icon>
                        </button>
                      </ng-container>

                      <ng-template #dataCell>
                        <ng-container [ngSwitch]="col.type">
                          <span *ngSwitchCase="'date'">
                            {{ row[col.key] | date:'shortDate' }}
                          </span>
                          <span *ngSwitchCase="'number'">
                            {{ row[col.key] }}
                          </span>
                          <span *ngSwitchDefault>
                            {{ row[col.key] ?? '-' }}
                          </span>
                        </ng-container>
                      </ng-template>

                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </ng-container>


        <!-- Fullscreen Projected Chart -->
        <ng-container *ngIf="fullscreenCard() === 'projected'">
          <canvas #fullscreenProjectedVolumeChart></canvas>
        </ng-container>

        <!-- Fullscreen Nutrition -->
        <ng-container *ngIf="fullscreenCard() === 'nutrition'">
          <div class="fullscreen-table-wrapper mat-elevation-z2">
            <table class="fixed_headers viewport dosinggridheight fullscreen_fixed_headers" style="width:98%;border:0 !important">
              <thead>
                <tr>
                  <th></th>
                  <th>Last Week</th>
                  <th>This Week</th>
                  <th>Next Week</th>
                </tr>
              </thead>
              <tbody style="width:101%;">
                <tr *ngFor="let item of nutritionalFacts()"
                    [ngClass]="item.DisplayText==='Nutritional Facts' ? 'nutheader' : ''">
                  <td>{{item.DisplayText}}</td>
                  <td>{{item.LastWeek}}</td>
                  <td>{{item.ThisWeek}}</td>
                  <td>{{item.NextWeek}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>


        <!-- Fullscreen: PROJECTED VOLUME TABLE -->
        <ng-container *ngIf="fullscreenCard() === 'table'">
          <div class="fullscreen-table-wrapper mat-elevation-z2">
            <table mat-table
                   [dataSource]="dataSourceProjected"
                   matSort
                   class="viewport full-table">

              <ng-container *ngFor="let col of projectedColumns" [matColumnDef]="col.key">

                <th mat-header-cell *matHeaderCellDef>
                  {{ col.header }}
                </th>

                <!-- Cell -->
                <td mat-cell *matCellDef="let row">
                  <ng-container [ngSwitch]="col.type">

                    <span *ngSwitchCase="'date'">
                      {{ row[col.key] | date:'shortDate' }}
                    </span>

                    <span *ngSwitchCase="'number'">
                      {{ row[col.key] }}
                    </span>

                    <span *ngSwitchDefault>
                      {{ row[col.key] ?? '-' }}
                    </span>

                  </ng-container>
                </td>

              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedProjectedColumns"></tr>

              <tr mat-row *matRowDef="let row; columns: displayedProjectedColumns"></tr>

            </table>

          </div>
        </ng-container>


      </div>
    </div>
  </div>


</div>
